import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import ProprietarioDashboard from './ProprietarioDashboard';
import ImpresaDashboard from './ImpresaDashboard';
import AdminDashboard from './AdminDashboard';

const DashboardRouter = () => {
  const { user } = useAuth();
  
  if (!user) return null;
  
  if (user.role === 'admin') return <AdminDashboard />;
  if (user.role === 'impresa') return <ImpresaDashboard />;
  return <ProprietarioDashboard />;
};

export default DashboardRouter;
